import * as React from 'react';
import Box from '@mui/material/Box';
import Bs4Kartoteka from '../Bs4Kartoteka';

export default function Bs4Box(props) {
  const [visibility, setVisibility] = React.useState(props.bs4Kartoteka?.visibility)

  React.useEffect(() => {
    if (props.bs4Kartoteka) props.bs4Kartoteka?.on(Bs4Kartoteka.CHANGE_VISIBILITY, setVisibility);
    setVisibility(props.bs4Kartoteka?.visibility);

    return () => {
      if (props.bs4Kartoteka) props.bs4Kartoteka?.off(setVisibility)
    }
  }, [setVisibility, props.bs4Kartoteka, props.bs4Kartoteka?.visibility])

  const newProps = {...props};
  delete newProps.bs4Kartoteka;

  // console.log('...BsBox...', visibility, props.bs4Kartoteka.getTitle(), props.bs4Kartoteka?.visibility);

  return (
    <Box {...newProps} visibility={visibility ? Bs4Kartoteka.VISIBILITY_VISIBLE : Bs4Kartoteka.VISIBILITY_HIDDEN}>
      {props.children}
    </Box>
  );
}
